import { FactoryProvider } from '@angular/core';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

export interface ComponentUpgradeOptions {
    inputs?: Array<string>;
    outputs?: Array<string>;
}

export interface HybridHelper {
    downgradeComponent(moduleName: string,
                       componentSelector: string,
                       componentClass: any,
                       options?: ComponentUpgradeOptions): HybridHelper;

    downgradeProvider(moduleName: string, providerName: string, providerClass: any): HybridHelper;

    buildProviderForUpgrade(ng1Name: string, ng2Name?: string): FactoryProvider;
}

// tslint:disable-next-line:only-arrow-functions
export function downgradeComponentF(moduleName: string,
                                    componentName: string,
                                    componentClass: any,
                                    options?: ComponentUpgradeOptions): HybridHelper {
    const _options = options || {};
    const inputs = _options.inputs || [];
    const outputs = _options.outputs || [];
    angular.module(moduleName)
        .directive(componentName, downgradeComponent({
            component: componentClass, inputs, outputs
        }) as angular.IDirectiveFactory);

    return hybridHelper;
}

// tslint:disable-next-line:only-arrow-functions
export function downgradeProviderF(moduleName: string, providerName: string, providerClass: any): HybridHelper {
    angular.module(moduleName)
        .factory(providerName, downgradeInjectable(providerClass));

    return hybridHelper;
}

// tslint:disable-next-line:only-arrow-functions
export function buildFactoryForUpgradeProvider(ng1Name: string): Function {
    return (injector: any) => injector.get(ng1Name);
}

export const hybridHelper: HybridHelper = {

    downgradeComponent: downgradeComponentF,
    /*
  downgradeComponent:
  (moduleName: string, componentName: string, componentClass: any, options?: ComponentUpgradeOptions): HybridHelper => {
    options = options || {};
    const inputs = options.inputs || [];
    const outputs = options.outputs || [];
    const component = componentClass;

    angular.module(moduleName).directive(componentName, downgradeComponent({
      component, inputs, outputs
    }) as angular.IDirectiveFactory);

    return hybridHelper;
  },
*/
    downgradeProvider: downgradeProviderF,
    /*
      downgradeProvider: (moduleName: string, providerName: string, providerClass: any): HybridHelper => {
        angular.module(moduleName).factory(providerName, downgradeInjectable(providerClass));

        return hybridHelper;
      },
    */

    // NOTE: This does not work with AOT ("function expressions are not supported in decorators")
    buildProviderForUpgrade: (ng1Name: string, ng2Name?: string): FactoryProvider => {

        const _ng2Name = ng2Name || ng1Name;

        return {
            provide: _ng2Name,
            useFactory: buildFactoryForUpgradeProvider(ng1Name),
            deps: ['$injector']
        };
    }

};
